import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class TagTemplatesElementDbTableDefinition extends DbTableDefinition {
    tableName = 'tagtemplateselements';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
      label TEXT NOT NULL,  
      databag LONGTEXT,
      parentid BIGINT(20),
      parentlabel TEXT,
      tagtemplateid BIGINT(20),
      tagtemplatelabel TEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}